import { atom } from "recoil";

const currentCallIdState = atom<string | null>({
  key: "currentCallId",
  default: null,
});

export default currentCallIdState;
